import React, { useRef, useState } from "react";

import InputText from "@app/components/2_widgets/inputs/InputText";
import ButtonSecondary from "@app/components/1_elements/ButtonSecondary";

import { useAuth } from '@app/contexts/AuthContext';
import { apiCall } from '@app/utils/apiCall';
import { useCustomer } from "@app/contexts/CustomerContext";

export default function DataPrevAddressInputs({}) {
    const customer = useCustomer();
    
    const [fullAddress, setFullAddress] = useState({
        address: customer.address, 
        city: customer.city, 
        postalCode: customer.postal_code
    });

    const auth = useAuth();
    

    const refAddress = useRef();
    const refCity = useRef();
    const refPostalcode = useRef();

    function updateCustomer(newValue, formKey) {
        if (customer.id) {
            const formData = new FormData();

            formData.append('customer[id]', customer.id);
            formData.append(`customer[${formKey}]`, newValue); 
            
            apiCall({
                method: "patch",
                path: `/api/v1/customers/${customer.id}`,
                auth: auth,
                data: formData,
                onSuccess: (response) => {
                    const cust = response.data.customer;

                    setFullAddress({
                        address: cust.address, 
                        city: cust.city, 
                        postalCode: cust.postal_code
                    })
                }
            });
        }
    }
    
    function showInput() {
        return (
            <>
                <div className="row">
                    <div className="col-5">
                        <InputText
                            ref={refAddress}
                            inputId="address"
                            defaultValue={fullAddress.address}
                            placeholder="1 rue de..."
                            callbackOnChange={(newValue) => updateCustomer(newValue, "address")}
                        />
                    </div>
                    <div className="col-2">
                        <InputText
                            ref={refPostalcode}
                            inputId="postalcode"
                            placeholder="29000..."
                            defaultValue={fullAddress.postalCode}
                            callbackOnChange={(newValue) => updateCustomer(newValue, "postal_code")}
                        />
                    </div>
                    <div className="col-3">
                        <InputText
                            ref={refCity}
                            inputId="city"
                            placeholder="Quimper, Douarnenez..."
                            defaultValue={fullAddress.city}
                            callbackOnChange={(newValue) => updateCustomer(newValue, "city")}
                        />
                    </div>                    
                </div>
            </>
        )
    }

    return (
        <>
            <div className="row input-edit">
                <div className="col-2 gray-text">Adresse</div>
                <div className="col-6">
                    {showInput()}
                </div>
            </div>
            
            <div className="gray-line mb-2 mt-2"></div>
        </>        
    )
}